import {
    SET_TRATAMIENTO,
    SET_NOMBRE,
    SET_APELLIDO_MATERNO,
    SET_APELIIDO_PATERNO,
    SET_ESTADO,
    SET_CIUDAD,
    SET_ID_CONCESIONARIO,
    SET_CONCESIONARIO,
    SET_TELEFONO,
    SET_MOVIL,
    SET_CORREO,
    SET_COMENTARIOS,
    SET_AVISO_PRIVACIDAD,
    SET_TERMINOS_Y_CONDICIONES,
    SET_TRANSFERENCIA_DE_DATOS,
    SET_CONTACO_MARKETING,
    SET_VEIHICULO,
    SET_TIPO_CITA,
    SET_NUMERO_DE_PARTE_ACCESORIOS,
    RESET_STATE,
} from "../types";

/**
 * Función para reiniciar el state
 * @returns
 */
export function reiniciarStateAction() {
    return async (dispatch) => {
        dispatch({ type: RESET_STATE });
    };
}

/**
 *
 * @param {*} inTratamiento
 * @returns
 */
export function setTratamientoAction(inTratamiento) {
    return (dispatch) => {
        dispatch(setTratamiento(inTratamiento));
    };
}
const setTratamiento = (inTratamiento) => ({
    type: SET_TRATAMIENTO,
    payload: inTratamiento,
});
/**
 *
 * @param {*} inNombre
 * @returns
 */
export function setNombreAction(inNombre) {
    return (dispatch) => {
        dispatch(setNombre(inNombre));
    };
}
const setNombre = (inNombre) => ({
    type: SET_NOMBRE,
    payload: inNombre,
});

/**
 *
 * @param {*} inApellidoPaterno
 * @returns
 */
export function setApellidoPaternoAction(inApellidoPaterno) {
    return (dispatch) => {
        dispatch(setApellidoPaterno(inApellidoPaterno));
    };
}
const setApellidoPaterno = (inApellidoPaterno) => ({
    type: SET_APELIIDO_PATERNO,
    payload: inApellidoPaterno,
});

/**
 *
 * @param {*} inApellidoMaterno
 * @returns
 */
export function setApellidoMaternoAction(inApellidoMaterno) {
    return (dispatch) => {
        dispatch(setApellidoMaterno(inApellidoMaterno));
    };
}
const setApellidoMaterno = (inApellidoMaterno) => ({
    type: SET_APELLIDO_MATERNO,
    payload: inApellidoMaterno,
});

/**
 *
 * @param {*} inTelefono
 * @returns
 */
export function setTelefonoAction(inTelefono) {
    return (dispatch) => {
        dispatch(setTelefono(inTelefono));
    };
}
const setTelefono = (inTelefono) => ({
    type: SET_TELEFONO,
    payload: inTelefono,
});

/**
 *
 * @param {*} inMovil
 * @returns
 */
export function setMovilAction(inMovil) {
    return (dispatch) => {
        dispatch(setMovil(inMovil));
    };
}
const setMovil = (inMovil) => ({
    type: SET_MOVIL,
    payload: inMovil,
});

/**
 *
 * @param {*} inCorreo
 * @returns
 */
export function setCorreoAction(inCorreo) {
    return (dispatch) => {
        dispatch(setCorreo(inCorreo));
    };
}
const setCorreo = (inCorreo) => ({
    type: SET_CORREO,
    payload: inCorreo,
});

/**
 *
 * @param {*} inEstado
 * @returns
 */
export function setEstadoAction(inEstado) {
    return (dispatch) => {
        dispatch(setEstado(inEstado));
    };
}
const setEstado = (inEstado) => ({
    type: SET_ESTADO,
    payload: inEstado,
});

/**
 *
 * @param {*} inCiudad
 * @returns
 */
export function setCiudadAction(inCiudad) {
    return (dispatch) => {
        dispatch(setCiudad(inCiudad));
    };
}
const setCiudad = (inCiudad) => ({
    type: SET_CIUDAD,
    payload: inCiudad,
});

/**
 *
 * @param {*} inIdConcesionario
 * @returns
 */
export function setIdConcesionarioAction(inIdConcesionario) {
    return (dispatch) => {
        dispatch(setIdConcesionario(inIdConcesionario));
    };
}
const setIdConcesionario = (inIdConcesionario) => ({
    type: SET_ID_CONCESIONARIO,
    payload: inIdConcesionario,
});

/**
 *
 * @param {*} inConcesionario
 * @returns
 */
export function setConcesionarioAction(inConcesionario) {
    return (dispatch) => {
        dispatch(setConcesionario(inConcesionario));
    };
}
const setConcesionario = (inConcesionario) => ({
    type: SET_CONCESIONARIO,
    payload: inConcesionario,
});

/**
 *
 * @param {*} inComentarios
 * @returns
 */
export function setComentariosAction(inComentarios) {
    return (dispatch) => {
        dispatch(setComentarios(inComentarios));
    };
}
const setComentarios = (inComentarios) => ({
    type: SET_COMENTARIOS,
    payload: inComentarios,
});

/**
 *
 * @param {*} inAvisosDePrivacidad
 * @returns
 */
export function setAvisosDePrivacidadAction(inAvisosDePrivacidad) {
    return (dispatch) => {
        dispatch(setAvisosDePrivacidad(inAvisosDePrivacidad));
    };
}
const setAvisosDePrivacidad = (inAvisosDePrivacidad) => ({
    type: SET_AVISO_PRIVACIDAD,
    payload: inAvisosDePrivacidad,
});

/**
 *
 * @param {*} inTerminosCondiciones
 * @returns
 */
export function setTerminosCondicionesAction(inTerminosCondiciones) {
    return (dispatch) => {
        dispatch(setTerminosCondiciones(inTerminosCondiciones));
    };
}
const setTerminosCondiciones = (inTerminosCondiciones) => ({
    type: SET_TERMINOS_Y_CONDICIONES,
    payload: inTerminosCondiciones,
});

/**
 *
 * @param {*} inTransferenciaDatos
 * @returns
 */
export function setTransferenciaDeDatosAction(inTransferenciaDatos) {
    return (dispatch) => {
        dispatch(setTransferenciaDeDatos(inTransferenciaDatos));
    };
}
const setTransferenciaDeDatos = (inTransferenciaDatos) => ({
    type: SET_TRANSFERENCIA_DE_DATOS,
    payload: inTransferenciaDatos,
});

/**
 *
 * @param {*} inContactoMarketing
 * @returns
 */
export function setContactoMarketingAction(inContactoMarketing) {
    return (dispatch) => {
        dispatch(setContactoMarketing(inContactoMarketing));
    };
}
const setContactoMarketing = (inContactoMarketing) => ({
    type: SET_CONTACO_MARKETING,
    payload: inContactoMarketing,
});

/**
 *
 * @param {*} inVehiculo
 * @returns
 */
export function setVehiculoAction(inVehiculo) {
    return (dispatch) => {
        dispatch(setVehiculo(inVehiculo));
    };
}
const setVehiculo = (inVehiculo) => ({
    type: SET_VEIHICULO,
    payload: inVehiculo,
});

/**
 *
 * @param {*} inTipoCita
 * @returns
 */
export function setTipoCitaAction(inTipoCita) {
    return (dispatch) => {
        dispatch(setTipoCita(inTipoCita));
    };
}
const setTipoCita = (inTipoCita) => ({
    type: SET_TIPO_CITA,
    payload: inTipoCita,
});

/**
 *
 * @param {*} inNumeroDeParte
 * @returns
 */
export function setNumeroDeParteAction(inNumeroDeParte) {
    return (dispatch) => {
        dispatch(setNumeroDeParte(inNumeroDeParte));
    };
}
const setNumeroDeParte = (inNumeroDeParte) => ({
    type: SET_NUMERO_DE_PARTE_ACCESORIOS,
    payload: inNumeroDeParte,
});
